import axios from 'axios';
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig, loginRequest, postLogoutRedirectUri } from "../../config/msalConfig";

const systemInfo = JSON.parse(window.sessionStorage.getItem("systemInfo"));
const userDetails = JSON.parse(window.localStorage.getItem("userInfo"));
const msalInstance = new PublicClientApplication(msalConfig);

function getRefreshToken() {
  return new Promise( (resolve) => {
    if (sessionStorage.getItem('oauthToken') != null || localStorage.getItem('oauthToken') != null) {
      try {
        const msalInstance = new PublicClientApplication(msalConfig);
        const currentAccount = JSON.parse(window.sessionStorage.getItem('home_account') || window.localStorage.getItem('home_account'));
        const silentRequest = {
            scopes: loginRequest.scopes,
            account: currentAccount,
        };
          msalInstance.acquireTokenSilent(silentRequest).then((response)=>{
            const oauth = {
              token_type: "Bearer",
              access_token: response.idToken
            }
            window.sessionStorage.setItem("oauthToken", JSON.stringify(oauth));
            resolve(oauth)
          }).catch(err=>{
            console.log(err);
            msalInstance.logoutRedirect({	
                postLogoutRedirectUri: postLogoutRedirectUri.redirectUri,	
                authority: msalConfig.auth.authority	
              });	
              // Optional: Redirect to login if token refresh fails
              window.sessionStorage.clear();
                window.localStorage.clear();
                window.sessionStorage.setItem('isLogout',true);
                window.localStorage.setItem('isLogout',true);
          })
      } catch (err) {
          console.log("Refresh token error",err)
      }
    } 
    else {
        window.sessionStorage.clear();
        window.localStorage.clear();
        window.sessionStorage.setItem('isLogout',true);
        window.localStorage.setItem('isLogout',true);
        window.location.href = "/login"
    }
  });
}

const authDetails = JSON.parse(window.sessionStorage.getItem("idToken"));

const audit = {
    emailId: userDetails?.email || "",
    firstName: userDetails?.firstName || "",
    lastName: userDetails?.lastName || "",
    userId: userDetails?.userId || "",
    roleId: userDetails?.roleId || "",
    ip: systemInfo?.ip || "",
    deviceId: systemInfo?.deviceId || "",
};

const request = axios.create({
    headers: {
        'accept': 'application/json',
        'Content-Type': 'application/json',
        "Authorization": `Bearer ${authDetails?.access_token}`,
        "Audit": JSON.stringify(audit),
    }
});

// Add request interceptor
request.interceptors.request.use((config) => {
    const authDetails = JSON.parse(window.sessionStorage.getItem("oauthToken"));
    const tenantInfo = window.sessionStorage.getItem("tenantID");
    
    const audit = {
        emailId: userDetails?.email || "",
        firstName: userDetails?.firstName || "",
        lastName: userDetails?.lastName || "",
        userId: userDetails?.userId || "",
        accountId: userDetails?.accountId || "",
        ip: systemInfo?.ip || "",
        deviceId: systemInfo?.deviceId || "",
    };

    const headers = {
        ...config.headers,
        Audit: config.url.includes("audit") || config.url.includes("lov") ? "" : JSON.stringify(audit),
        "X-ROLE-ID": userDetails?.role || "",
        "X-TENANT-ID": tenantInfo || "",
    };

    if (authDetails && authDetails.access_token) {
        config.headers.Authorization = `Bearer ${authDetails.access_token}`;
    }

    return config;
}, (error) => {
    console.error("Request error", error);
    return Promise.reject(error);
});

// Add response interceptor for handling 401 and token refresh
request.interceptors.response.use(
    (response) => response, // Pass through the response as is for success
    async (error) => {
      const originalRequest = error.config;
  
      // Check if the error is due to an expired token (401 Unauthorized)
      if (error.response?.status === 401 && !originalRequest.retry ) {
        originalRequest.retry = true; // Mark the request to prevent infinite loops
        try {
          // Refresh the token
          await getRefreshToken();
          // Update the Authorization header with the new token
          const oauthToken = JSON.parse(sessionStorage.getItem("oauthToken"));
          originalRequest.headers.Authorization = `Bearer ${oauthToken?.access_token}`;
  
          // Retry the original request
          return axios.request(originalRequest);
        } catch (refreshError) {
          console.error("Token refresh failed", refreshError);
          msalInstance.logoutRedirect({	
            postLogoutRedirectUri: postLogoutRedirectUri.redirectUri,	
            authority: msalConfig.auth.authority	
          });	
          // Optional: Redirect to login if token refresh fails
          window.sessionStorage.clear();
            window.localStorage.clear();
            window.sessionStorage.setItem('isLogout',true);
            window.localStorage.setItem('isLogout',true);
        //   
  
          return Promise.reject(refreshError);
        }
      }
  
      // Reject for other errors
      return Promise.reject(error);
    }
  );
  

export default request;